// extracted by mini-css-extract-plugin
module.exports = {"container":"Entity_container__GRUJz","textWrap":"Entity_textWrap__3sY6h","icon":"Entity_icon__2ZXlZ","editing":"Entity_editing__1PEk-","text":"Entity_text__33JfR"};